import View from './Vertical'
import { connect } from 'react-redux'
import { compose } from 'ramda'
import { click } from '../../../../store/modules/marketSpaces'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  click: compose(dispatch, click),
})

const Vertical = connect(mapStateToProps, mapDispatchToProps)(View)

export default Vertical
